/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $timeout,
  uiService,
  webpage,
  helperService,
  eventService,
  authenticationService,
  dashboardService,
  workflowsService,
  Dashboard,
  DashboardItem,
  DASHBOARD
) => {
  $scope.Model = {
    availableWidgetGroups: [],
    availableWidgets: [],
    activeDashboard: {},
    itemTemplate: {
      name: 'New Widget',
      key: '',
      dim: [1, 1]
    },
    itemAddMoreTemplate: {
      name: 'Add another widget',
      key: 'st_add_widgets',
      loc: [999, 999],
      dim: [1, 1],
      min: [1, 1],
      max: [1, 1]
    },
    itemPropertyMap: {
      col: 'item.loc[0]',
      row: 'item.loc[1]',
      sizeX: 'item.dim[0]',
      sizeY: 'item.dim[1]',
      minSizeX: 'item.min[0]',
      minSizeY: 'item.min[1]',
      maxSizeX: 'item.max[0]',
      maxSizeY: 'item.max[1]'
    },
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Home');
  $q.all([
    dashboardService.readDashboard(Dashboard.blank()),
    workflowsService.getAvailable({ isActive: true })
  ]).then((data) => {
    $timeout(() => {
      const widgets = dashboardService.getWidgets();
      $scope.Model.availableWidgets = _.groupBy(widgets, (wig) => wig.group.section);
      _.forEach(_.keys($scope.Model.availableWidgets), (key) => {
        $scope.Model.availableWidgets[key] = _.groupBy(
          $scope.Model.availableWidgets[key],
          (wig) => wig.group.object || wig.group.status
        );
        $scope.Model.availableWidgets[key].sections = _.keys(
          $scope.Model.availableWidgets[key]
        );
      });
      $scope.Model.availableWidgets.sections = _.keys($scope.Model.availableWidgets);
    });

    if (data && data.length && data[0].id) {
      $scope.Model.activeDashboard = data[0];
    } else {
      $scope.Model.activeDashboard = Dashboard.build(DASHBOARD.DEFAULT);
      $scope.Model.activeDashboard.items.push(
        DashboardItem.build($scope.Model.itemAddMoreTemplate)
      );
    }
    if ($rootScope.isDev() || $rootScope.isNlg() || $rootScope.isPtf()) {
      $scope.Model.availableWorkflows = _.filter(data[1], (w) => w?.isAssetFinance());
    } else {
      $scope.Model.availableWorkflows = data[1];
    }
    $scope.Model.isReady = true;
  });

  $scope.removeDashboardItem = ($event, item) => {
    $event.stopPropagation();
    $scope.Model.isReady = false;
    const idx = _.findIndex($scope.Model.activeDashboard.items, (i) => i.name === item.name);
    if (idx > -1) {
      $scope.Model.activeDashboard.items.splice(idx, 1);
      dashboardService.updateDashboard($scope.Model.activeDashboard);
    }
    $timeout(() => {
      $scope.Model.isReady = true;
    }, 750);
  };

  $scope.addDashboardItem = ($event, widget) => {
    $event.stopPropagation();
    const hasAlreadyAdded = $scope.Model.activeDashboard.items.find(
      (w) => w.key === widget.key
    );
    if (!hasAlreadyAdded) {
      const newWidget = DashboardItem.blank();
      newWidget.key = widget.key;
      newWidget.name = widget.name;
      newWidget.dim = widget.dim;
      newWidget.min = widget.min;
      $scope.Model.activeDashboard.items.push(newWidget);
      dashboardService.createDashboard($scope.Model.activeDashboard).then((result) => {
        if (result.status) {
          uiService.toast({
            text: {
              p1: 'Widget',
              p2: widget.name,
              p3: 'has been added'
            }
          });
        }
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Widget',
          p2: widget.name,
          p3: 'has been already added'
        },
        warn: true
      });
    }
  };

  $scope.gridsterOptions = {
    columns: 6,
    pushing: true,
    floating: true,
    swapping: false,
    width: 'auto',
    colWidth: 'auto',
    rowHeight: 'match',
    margins: [20, 20],
    outerMargin: true,
    sparse: false,
    isMobile: false,
    mobileBreakPoint: 960,
    mobileModeEnabled: true,
    minColumns: 1,
    minRows: 2,
    maxRows: 100,
    defaultSizeX: 1,
    defaultSizeY: 1,
    minSizeX: 1,
    maxSizeX: null,
    minSizeY: 1,
    maxSizeY: null,
    resizable: {
      enabled: true,
      handles: ['se'],
      start: () => {},
      resize: () => {},
      stop: () => {
        dashboardService.createDashboard($scope.Model.activeDashboard).then((result) => {
          if (result.status && $scope.Model.activeDashboard.id === '') {
            $scope.Model.activeDashboard.id = result.id;
          }
        });
      }
    },
    draggable: {
      enabled: true,
      handle: '.gridster-item .anchor',
      start: () => {},
      drag: () => {},
      stop: () => {
        dashboardService.createDashboard($scope.Model.activeDashboard).then((result) => {
          if (result.status && $scope.Model.activeDashboard.id === '') {
            $scope.Model.activeDashboard.id = result.id;
          }
        });
      }
    }
  };

  $scope.quickToolAssetFinanceQuickQuote = ($event) => {
    eventService.quickToolAssetFinanceQuickQuote({ event: $event });
  };
};
